import React, { useEffect } from "react";
import { siteData } from "../mock";
import { CalendarDays } from "lucide-react";

export default function Hero() {
  const brand = siteData.brand.name;
  const letters = brand.split("");

  useEffect(() => {
    // Load Calendly widget script once
    if (document.querySelector('script[src*="calendly.com/assets/external/widget.js"]')) return;
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-24"
    >
      {/* Storefront backdrop */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="https://customer-assets-m6fa6gv7.emergentagent.net/job_elite-fitness-build-5/artifacts/1ywz7boj_IMG_0013.jpeg"
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover opacity-55 scale-105"
        />
        {/* Dark gradient overlays for readability */}
        <div className="absolute inset-0 bg-[#0a0a0a]/45" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a]/85 via-[#0a0a0a]/30 to-[#0a0a0a]" />
      </div>

      {/* Grid background overlay */}
      <div className="absolute inset-0 bg-grid-lines opacity-40 pointer-events-none" />

      {/* Red radial glows */}
      <div className="absolute -top-40 -left-40 w-[600px] h-[600px] bg-red-700/25 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute -bottom-40 -right-40 w-[600px] h-[600px] bg-red-600/20 rounded-full blur-[120px] pointer-events-none" />

      <div className="relative z-10 max-w-[1400px] w-full mx-auto px-6 lg:px-10 py-16 text-center animate-fade-up">
        {/* Wordmark */}
        <h1 className="font-wordmark font-normal tracking-wide leading-none text-white select-none">
          <span className="block text-[18vw] md:text-[15vw] lg:text-[12vw] xl:text-[11rem]">
            {letters.map((l, i) => (
              <span key={i} className={i === 3 ? "deal-yellow" : ""}>{l}</span>
            ))}
          </span>
        </h1>

        {/* Sub-brand */}
        <div className="mt-2 md:mt-4">
          <p className="text-white font-wordmark tracking-wide text-5xl md:text-7xl lg:text-8xl">
            {siteData.brand.tagline}
          </p>
        </div>

        {/* Certification pill */}
        <div className="mt-10 flex justify-center">
          <div className="inline-flex items-center gap-3 px-8 py-3 rounded-md border border-[#e10600]/40 bg-[#2a0000]/60">
            <span className="deal-yellow font-heading font-semibold tracking-[0.2em] text-sm md:text-base">
              {siteData.brand.certification}
            </span>
          </div>
        </div>

        {/* Description */}
        <div className="mt-10 max-w-2xl mx-auto">
          <p className="text-white/85 text-lg md:text-xl leading-relaxed font-light">
            {siteData.brand.heroDescription}
          </p>
          <p className="mt-4 italic font-semibold text-white text-lg md:text-xl tracking-wide">
            {siteData.brand.heroCallout}
          </p>
        </div>

        {/* Location pill */}
        <div className="mt-10 flex justify-center">
          <div className="inline-flex items-center gap-2 px-6 py-2 rounded-md border border-[#e10600]/40">
            <span className="deal-yellow font-heading font-semibold tracking-[0.28em] text-sm">
              {siteData.brand.location}
            </span>
          </div>
        </div>

        {/* Calendly Embed */}
        <div className="mt-14 max-w-4xl mx-auto text-left">
          <div className="flex items-center justify-center gap-3 mb-5">
            <CalendarDays size={20} className="deal-yellow" />
            <span className="deal-yellow font-heading font-semibold tracking-[0.3em] text-sm md:text-base">
              BOOK YOUR SESSION
            </span>
          </div>
          <div className="rounded-2xl overflow-hidden border border-[#e10600]/25 bg-[#0f0f0f] shadow-[0_20px_60px_-20px_rgba(225,6,0,0.35)]">
            <div
              className="calendly-inline-widget"
              data-url={`${siteData.calendly.hero}?hide_gdpr_banner=1&background_color=0f0f0f&text_color=ffffff&primary_color=e10600`}
              style={{ minWidth: "320px", height: "700px" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
